const Subcategories = () => {
  const screenWidth = window.innerWidth;
  const categoryLinks = [...document.querySelectorAll(".categories-menu__category-link")];
  const subcategoriesLists = [...document.querySelectorAll(".categories-menu__subcategories-lists")];
  const subcategoriesWrapper = document.querySelector(".categories-menu__subcategories-wrapper");
  const backBtn = document.querySelector(".categories-menu__back-btn");

  if (screenWidth > 1023) {
    categoryLinks[0].classList.add("active");
    subcategoriesLists[0].classList.add("active");
  }
  
  const deactivateAllSubcategories = () => {
    subcategoriesLists.forEach((subcategoriesList) => {
      subcategoriesList.classList.remove("active");
    });

    categoryLinks.forEach((categoryLink) => {
      categoryLink.classList.remove("active");
    });
  };

  if (categoryLinks.length > 0) {
    categoryLinks.forEach((categoryLink) => {
      const handleCategoryInteraction = () => {
        deactivateAllSubcategories();

        categoryLinks.forEach((link) => {
          link.classList.remove("active");
        });

        categoryLink.classList.add("active");
        //Tablet
        subcategoriesWrapper.classList.add("active");
        backBtn.classList.add("visible");
        //

        const categoryValue = categoryLink.dataset.category;
        const relatedSubcategoriesList = document.querySelector(`.categories-menu__subcategories-lists[data-category="${categoryValue}"]`);

        if (relatedSubcategoriesList) {
          relatedSubcategoriesList.classList.add("active");
        }
      };

      if (screenWidth > 1023) {
        categoryLink.addEventListener("mouseenter", handleCategoryInteraction);
      }

      // Tablet   
      const categoryArrowBtns = [...categoryLink.querySelectorAll(".categories-menu__category-link .arrow-tablet")];

      categoryArrowBtns.forEach((categoryArrowBtn) => {
        categoryArrowBtn.addEventListener("click", (e) => {
          e.preventDefault();
          handleCategoryInteraction();
        });
      });
      //
    });
  }

  // Tablet 
  if (backBtn) {
    backBtn.addEventListener("click", () => {
      subcategoriesWrapper.classList.remove("active");
      backBtn.classList.remove("visible");
    });
  }

  const subcategoriyAccordions = [...document.querySelectorAll(".categories-menu__subcategories-list")];

  if (screenWidth <= 1023 && subcategoriyAccordions.length > 0) {  
    subcategoriyAccordions.forEach((subcategoriyAccordion) => {
      const subcategoriesTitle = subcategoriyAccordion.querySelector(".categories-menu__subcategory-title");
      const subcategoriesLinksWrapper = subcategoriyAccordion.querySelector(".categories-menu__subcategories-links-wrapper");
      const arrowIcon = subcategoriesTitle.querySelector(".arrow-tablet");

      //Render arrow icon
      if (subcategoriesLinksWrapper) {
        arrowIcon.classList.add("visible");
      }

      arrowIcon.addEventListener("click", (e) => {
        if (subcategoriesLinksWrapper) {
          e.preventDefault();
          subcategoriesTitle.classList.toggle("active");
          subcategoriesLinksWrapper.classList.toggle("opened");
        }
      })
    })
  }
};

export default Subcategories;


